import {
  Inquiry,
  InquiryAttributes,
  InquiryRelationships,
  InquiryStatus,
} from 'dashboard/models/inquiry';
import { ApiModel } from 'lib/interfaces/api';

const createdAt = '2023-01-01T00:00:00.000Z';
const completedAt = '2023-01-01T00:01:00.000Z';

export function createPreviewInquiry(
  attributes?: Partial<InquiryAttributes>,
  relationships?: Partial<InquiryRelationships>,
  id?: string,
): Inquiry {
  return {
    attributes: {
      status: InquiryStatus.Completed,
      /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
      'reference-id': null,
      'created-at': createdAt,
      'completed-at': completedAt,
      /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
      'expired-at': null,
      /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
      'failed-at': null,
      /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
      'redacted-at': null,
      'phone-number': '8675309',
      /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
      'email-address': null,
      'name-full': 'ALEXANDER J SAMPLE',
      'name-first': 'ALEXANDER',
      'name-middle': 'J',
      'name-last': 'SAMPLE',
      birthdate: '1977-07-17',
      'social-security-number': '123456789',
      'identification-number': 'I1234562',
      'address-street-1': '600 CALIFORNIA STREET',
      /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
      'address-street-2': null,
      'address-city': 'SAN FRANCISCO',
      'address-subdivision': 'CA',
      'address-postal-code': '94109',
      'address-country-code': 'US',
      /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
      'reviewer-comment': null,
      /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
      'selfie-photo-url': null,
      /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
      'reusable-persona-risk-signals': null,
      fields: {},

      ...attributes,
    },
    id: id || 'inq_123',
    relationships: {
      account: {
        data: {
          id: 'account_id',
          type: ApiModel.Account,
        },
      },
      cases: {
        data: [],
      },
      creator: {
        /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
        data: null,
      },
      devices: {
        data: [],
      },
      documents: {
        data: [],
      },
      environment: {
        data: {
          id: 'environment_id',
          type: ApiModel.EnvironmentProduction,
        },
      },
      'inquiry-template': {
        data: null,
      },
      'inquiry-template-version': {
        data: null,
      },
      'list-matches': {
        data: [],
      },
      redactor: {
        /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
        data: null,
      },
      reviewer: {
        /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
        data: null,
      },
      reports: {
        data: [],
      },
      selfies: {
        data: [],
      },
      sessions: {
        data: [],
      },
      tags: {
        data: [],
      },
      template: {
        data: {
          id: 'app_id',
          type: ApiModel.Template,
        },
      },
      theme: {
        data: {
          id: 'theme_id',
          type: ApiModel.Theme,
        },
      },
      verifications: {
        data: [],
      },
      ...relationships,
    },
    type: ApiModel.Inquiry,
  };
}
